(() => {
  if (window.olyrelIpShippingNoteInitialized) return;
  window.olyrelIpShippingNoteInitialized = true;

  const selector = '[data-olyrel-ip-shipping-note]';
  const isSpanish = /^es(?:-|$)/i.test(document.documentElement.lang);
  const usCopy = isSpanish ? 'Envío y aranceles incluidos para entregas en Estados Unidos*' : 'Shipping and tariffs included for delivery to United States*';
  const worldwideCopy = isSpanish ? 'Envío gratuito a todo el mundo' : 'Worldwide free shipping';
  let resolved = false;
  let country = null;

  function updateNotes(root) {
    if (!resolved) return;
    const notes = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) notes.unshift(root);
    for (const note of notes) {
      const isUsd = note.dataset.olyrelCurrency === 'USD';
      const copy = country === 'US' && isUsd ? usCopy : worldwideCopy;
      if (note.textContent !== copy) note.textContent = copy;
      note.dataset.ipShippingCountry = country || 'unknown';
    }
  }

  // Variant changes replace the price markup. Apply the same detected country
  // to newly inserted notes, without making another geolocation request.
  new MutationObserver(records => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) updateNotes(node);
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 4000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true', {
    credentials: 'same-origin',
    cache: 'no-store',
    signal: controller.signal,
    headers: { Accept: 'application/json' },
  })
    .then(response => {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    })
    .then(data => {
      // Use the IP-detected value, never the selected market or currency.
      const detected = data?.detected_values?.country?.handle;
      if (typeof detected === 'string' && /^[a-z]{2}$/i.test(detected)) {
        country = detected.toUpperCase();
      }
    })
    .catch(() => {
      // Without a detected US IP, show the worldwide shipping message.
      country = null;
    })
    .finally(() => {
      clearTimeout(timeout);
      resolved = true;
      updateNotes(document);
    });
})();
